import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import successemail from "../images/email_success.svg";
import failureemail from "../images/email_failure.svg";
import api from '../../services/api';
import Loader from '../common/Loader';

const ConfirmEmail = () => {
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    let token = queryParams.get('token');
    if (token) {
      token = token.replace(/ /g, '+');
    }

    if (!token) {
      setMessage('No token found in the URL');
      setLoading(false);
      return;
    }

    confirmEmail(token);
  }, []);

  const confirmEmail = async (token) => {
    try {
      await api.auth.confirmemail(token);
      setStatus(true);
      setMessage('Congratulations! Your email address has been successfully verified. You can now continue to the main application.');
      navigate(`/set-password?token=${encodeURIComponent(token)}`);

    } catch (error) {
      setMessage(error.message || 'We were unable to verify your email address. Please check the link and try again.');
      setStatus(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center">
      <div className="bg-white p-8 max-w-md w-full">
        <div className="text-center">
          {status ? (
            <div>
              <img src={successemail} alt="success" className='m-auto' />
              <h2 className="text-xl font-semibold text-black-600 my-4">Email Confirmed!</h2>
              <p className="mt-2 text-sm text-black-600">{message}</p>
            </div>
          ) : (
            <div>
              <img src={failureemail} alt="failure" className='m-auto' />
              <h2 className="text-xl font-semibold text-black-600 my-4">Email Verification Failed</h2>
              <p className="mt-2 text-sm text-black-600">{message}</p>
            </div>
          )}
        </div>
      </div>
      {
        loading && <Loader />
      }
    </div>

  );
};

export default ConfirmEmail;
